import BaseAPI from './base.api.service'

const resource = 'miscreports';
export default {
    async get(erID) {
        return await BaseAPI.get(`ExpenseReports/${erID}/MiscReport`);
    },
    async getItemTypes() {
        return await BaseAPI.get(`${resource}/ItemTypes`);
    },
    async save(request) {
        return await BaseAPI.post(`${resource}/`, request)
    },
    async submit(request) {
        return await BaseAPI.post('expensereports/Submission', request)
    }
}